<template>
  <div :class="['widget', {'border-error': error}]">

    <v-container style="padding-bottom: 0;">

      <div id="custom-header">
        <span class="subheading">
          Comments ({{ comments.length }})
        </span>
        <v-btn
          class="ma-0"
          icon
          @click="newComment = ''; dialog = true;">
          <v-icon>add</v-icon>
        </v-btn>
      </div>
    </v-container>

    <template v-if="loading">
      <v-layout
        align-center
        justify-center
        fill-height>
        <v-progress-circular
          size="50"
          indeterminate/>
      </v-layout>
    </template>

    <template v-else>
      <div
        v-for="(comment, index) in comments"
        :key="comment.id">
        <v-container style="padding: 12px 24px 0px 24px">
          <v-layout
            align-center
            justify-space-between>
            <v-flex grow>
              <span class="body-2">
                {{ comment.author | emailToName }}
              </span>
            </v-flex>
            <v-flex shrink>
              <v-tooltip left>
                <span
                  slot="activator"
                  class="caption">
                  {{ comment.dateCreated | formatFn }}
                </span>
                <span>{{ comment.dateCreated | formatLLL }}</span>
              </v-tooltip>
              <v-btn
                v-if="comments[index].deleting === true"
                class="ma-0"
                disabled
                icon>
                <v-progress-circular
                  indeterminate
                  size="20"/>
              </v-btn>
              <v-btn
                v-else
                :disabled="comments[index].loading === true"
                class="ma-0"
                color="red--text text--lighten-3"
                icon
                @click="remove(index)">
                <v-icon>remove</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-container style="padding: 0 0 9px 12px">
            <v-layout>
              <em>{{ comment.content }}</em>
            </v-layout>
          </v-container>
          <v-divider style="background-color: #404040;"/>
        </v-container>
      </div>
    </template>


    <v-dialog
      v-model="dialog"
      persistent
      max-width="50rem">
      <v-card>
        <v-card-text>
          <v-container style="padding-bottom: 0;">
            <v-layout>
              <v-flex>
                <v-form v-model="valid">
                  <v-textarea
                    v-model="newComment"
                    :rules="[v => !!v || 'A comment is required.']"
                    auto-grow
                    label="Comment"
                    outline
                    rows="1"/>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="add">
            <v-progress-circular
              v-if="posting"
              indeterminate
              size="20"/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "sites-comments",
  filters: {
    emailToName (email) {
      /**
       * @param {string} email - The user's email in the form:
       *     ''
       * @returns {string} name - If the email:
       *   1. is like 'firstname.lastname@thinxtra.com': 'Firstname Lastname'
       *   2. ain't like ...: 'Unidentified'
       */
      if (typeof email === "string") {
        let name = "";
        const r = /^([a-z]*)\.([a-z]*)@thinxtra.com$/;
        if (r.exec(email)) {
          const [, firstname, lastname] = r.exec(email);
          name += firstname.charAt(0).toUpperCase() + firstname.slice(1);
          name += " ";
          name += lastname.charAt(0).toUpperCase() + lastname.slice(1);
          return name;
        }
      }
      return "Unidentified";
    }
  },
  data () {
    return {
      dialog: false,
      comments: [],
      error: false,
      loading: false,
      newComment: "",
      posting: false,
      valid: false
    };
  },
  computed: {
    email () {
      const re = /(?:^|; )sitePass(?:=([^;]*))?(?:;|$)/;
      const result = re.exec(document.cookie);
      if (result === null) {
        return "default";
      }
      const [, token] = result;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.accessName;
    }
  },
  created () {
    this.loading = true;
    this.getAll();
  },
  methods: {
    add () {
      this.posting = true;
      const comment = {
        author: this.email,
        content: this.newComment,
        dateCreated: moment().format("YYYY-MM-DDTHH:mm:ss")
      };
      this.$http.
        post(`/api/sites/${this.$route.params.id}/comments`, comment).
        then(() => this.getAll()).
        then(() => this.dialog = false).
        catch(() => this.error = true).
        finally(() => this.posting = false);
    },
    getAll () {
      this.$http.
        get(
          `/api/sites/${this.$route.params.id}/comments`,
          { headers: { "Cache-Control": "no-cache" } }
        ).
        then((r) => this.comments = Array.from(
          r.data.reverse().map((obj) =>
            Object.assign(obj, {
              deleting: false,
              loading: false
            }))
        )).
        catch(() => this.error = true).
        finally(() => this.loading = false);
    },
    remove (index) {
      if (confirm("Remove this comment (unrecoverable)?")) {
        const { id } = this.comments[index];
        this.comments[index].deleting = true;
        this.$http.
          delete(`/api/sites/${this.$route.params.id}/comments/${id}`).
          then(() => this.getAll()).
          finally(() => this.comments[index].deleting = false);
      }
    }
  }
};
</script>

<style scoped>
#custom-header {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  justify-content: space-between;
}
label {
  display: flex;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
}
label:hover {
  background-color: #494949;
  cursor: pointer;
}
label i {
  flex: auto;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Site/Comments.vue